import { Dropdown } from "react-bootstrap";
import styled from "styled-components";

export const DropdownMenu = styled(Dropdown.Menu)`
  border: 1px solid #fff;
`;
